// extracted by mini-css-extract-plugin
export default {"dot":"LoadingDots_dot__ZK+Eh","flashing":"LoadingDots_flashing__z+UNv"};